module.exports = __webpack_public_path__ + "static/media/generate.2cc5a3a5.PNG";